import Axios from "axios";

export class Subscriber {
  // Set subscriber url
  constructor(apiUrl, headers) {
    this.subscriberUrl = `${apiUrl}/subscriptions/subscribers`;
    this.headers = headers;
  }

  async getDecryptedIdCard(id) {
    const url = `${this.subscriberUrl}/${id}/decrypt/id-card`;

    const response = await Axios.get(url, {
      headers: this.headers
    });

    return response;
  }
}
